import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { Box, IconButton, Typography } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { Robot, createRobot } from "../models/Robot";
import { loadOrgModel, loadOrgRecord } from "../api/connection";
import { useParams } from "react-router-dom";
import Renderer3D from "../components/Renderer3D";
import WsManagement from "../api/WsManagement";
import ThreeDScene from "../components/ThreeDScene";
// import { FpvCamera } from "./sim/FpvCamera";
import { MapFloorFactory } from "../components/threeDComponents/MapFloorFactory";
import { BaseActor } from "../components/threeDComponents/behaviors/BaseActor";
import { GLTFResult } from "../api/threed";
// import { RobotControlPanel } from "./control/RobotControlPanel";

export default function ControlPanelPage() {
  const { id } = useParams<{ id: string }>();
  const [robot, setRobot] = useState<Robot | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const wsManagement = new WsManagement();
  const [scene, setScene] = useState<ThreeDScene | null>(null);
  const [cameraPrimary, setCameraPrimary] = useState<boolean>(false);
  const [fpvCameraActor, setFpvCameraActor] = useState<BaseActor | null>(null);
  const remoteControlDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scene) {
      const modelCache: GLTFResult = {
        scene: new THREE.Object3D(),
        animations: [],
      };
      // const newRobotActor = new RobotActor(scene, modelCache);
      // setRemoteControlRobot(newRobotActor);
    }
  }, [scene]);

  useEffect(() => {
    const fetchRobot = async () => {
      try {
        const robot = createRobot(id);
        await loadOrgModel(robot);
        setRobot(robot || null);
      } catch (err) {
        console.error("Error fetching robot:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRobot();
  }, [id]);

  useEffect(() => {
    if (scene) {
      const gltfResult: GLTFResult = {
        scene: new THREE.Object3D(),
        animations: [],
      };
      const newCameraActor = new BaseActor(scene, gltfResult);
      setFpvCameraActor(newCameraActor);
    }
  }, [scene]);

  function switchPrimary(primary: "camera" | "map") {
    setCameraPrimary(primary === "camera");
  }

  if (loading) return <Typography>Loading...</Typography>;
  if (!robot) return <Typography>Robot not found</Typography>;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        color: "#ECECEC",
        overflow: "hidden",
        px: 1,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          position: "relative",
          height: "100%",
        }}
      >
        {scene && (
          <Box
            sx={{
              display: "flex",
              position: "absolute",
              width: "Calc 50vw",
              bottom: 20,
              justifyContent: "center",
              alignItems: "center",
              height: 100,
              zIndex: 10,
            }}
            ref={remoteControlDiv}
          >
            {/* <RobotControlPanel
              wsManagement={wsManagement}
              scene={scene}
              remoteControlRobot={remoteControlRobot}
            /> */}
          </Box>
        )}
        <Box
          onClick={() => switchPrimary("camera")}
          sx={{
            position: "absolute",
            width: cameraPrimary ? "100%" : "550px",
            height: cameraPrimary ? "100%" : "350px",
            bottom: cameraPrimary ? 0 : "10px",
            right: cameraPrimary ? 0 : "10px",
            backgroundColor: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid white",
            cursor: "pointer",
          }}
        >
          {/* {scene && <FpvCamera wsManagement={wsManagement} scene={scene} />} */}
        </Box>

        <Box
          // onClick={() => switchPrimary('map')}
          sx={{
            position: "absolute",
            width: cameraPrimary ? "550px" : "100%",
            height: cameraPrimary ? "350px" : "100%",
            bottom: cameraPrimary ? "10px" : 0,
            right: cameraPrimary ? "10px" : 0,
            backgroundColor: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid white",
            cursor: "pointer",
          }}
        >
          <Renderer3D
            height="100%"
            wsManagement={wsManagement}
            setSceneCallback={setScene}
          />
          <IconButton
            sx={{
              display: cameraPrimary ? "flex" : "none",
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
            }}
            onClick={() => switchPrimary("map")}
          >
            <SwapHorizIcon />
          </IconButton>
        </Box>
      </Box>

      {scene && (
        <Box
          sx={{
            width: "550px",
            height: "350px",
            position: "absolute",
            bottom: "10px",
            right: "10px",
            cursor: "pointer",
            backgroundColor: "#000",
            display: cameraPrimary ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid white",
          }}
          onClick={() => switchPrimary("camera")}
        >
          {/* <FpvCamera wsManagement={wsManagement} scene={scene} /> */}
          <IconButton
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
            }}
            onClick={() => {
              switchPrimary("camera");
            }}
          >
            <SwapHorizIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}
